module.exports = __webpack_public_path__ + "static/media/imagotype_primary.185671cc.svg";